// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/css/10.1f94a0116067c7784c23.lib.css";
	if (chunkId === 378) return "static/css/378.4a184d743f33e359b43b.css";
	// return url for filenames based on template
	return undefined;
};